import toast from "react-hot-toast";
import { formatDateDb, formatDateHourDb } from "../../utils/tools";
import { customDateFormatType } from "../../utils/utils";

const { clientAPI } = require("../client");
export const ttkqCall = {
  create: async (data) => {
    try {
      const response = await clientAPI("post", "/ttkq", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await clientAPI("put", `/ttkq/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  approve: async (id, data) => {
    try {
      const response = await clientAPI("put", `/ttkq/approve/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  revert: async (id) => {
    try {
      const response = await clientAPI("put", `/ttkq/revert/${id}`);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  updateHiddenStatus: async (id) => {
    try {
      const response = await clientAPI("put", `/ttkq/updateHiddenStatus/${id}`);
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  bulkImport: async (data) => {
    try {
      const response = await clientAPI("post", "/ttkq/bulkImport/", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  transfer: async (id, data) => {
    try {
      const response = await clientAPI("put", `/ttkq/app/transfer/${id}`, data);
      return response;
    } catch (error) {
      console.error("transfer error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  export: async (entries, param) => {
    try {
      const options = {
        limit: entries,
        page: 1,
      };

      if (param.search !== undefined) options.search = param.search;
      if (param.creatorId) options.creatorId = param.creatorId;
      if (param.status?.length) options.status = param.status;

      if (param.projectId?.length) options.projectId = param.projectId;
      if (param.apartmentId?.length) options.apartmentId = param.apartmentId;
      if (param.customerId) options.customerId = param.customerId;
      if (param.startTime)
        options.startTime = customDateFormatType(param.startTime);
      if (param.endTime) options.endTime = customDateFormatType(param.endTime);
      if (param.saleBlockId) options.saleBlockId = param.saleBlockId;
      if (param.saleAreaId) options.saleAreaId = param.saleAreaId;

      const queryParams = new URLSearchParams(options).toString();
      const response = await clientAPI("get", `/ttkq?${queryParams}`);
      const dataExport = response?.items.map((item) => {
        return {
          status: getStatusText(item?.status) || "",
          projectName: item?.locking?.projectObject?.name || "",
          apartmentCode: item?.locking?.apartmentObject?.code || "",
          customerName: item?.customerObject?.name || "",
          time: item?.time ? formatDateDb(item?.time) : "",
          priceTime: item?.priceTime ? formatDateDb(item?.priceTime) : "",
          creator:
            item?.creatorObject?.fullName || item?.creator?.fullName || "",
          saleBlockName: item?.creator?.saleBlock?.name || "",
          saleAreaName: item?.creator?.saleArea?.name || "",
          createdAt: item?.createdAt ? formatDateHourDb(item?.createdAt) : "",
          approver:
            item?.approverObject?.fullName || item?.approver?.fullName || "",
          approverDate: item?.approverDate
            ? formatDateDb(item?.approverDate)
            : "",
        };
      });

      return dataExport;
    } catch (error) {
      console.error("get list error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
   getTypeImage: async (id) => {
    try {
      const response = await clientAPI("get", `/ttkq/getTypeImage/${id}`);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  downloadPDF: async (id, payload) => {
    try {
      const response = await clientAPI("put", `/ttkq/downloadPDF/${id}`, payload);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};

export const getStatusText = (status) => {
  switch (status) {
    case "APPROVED":
      return "Đã được duyệt";
    case "REFUND":
      return "Đã hoàn trả";
    case "REJECTED":
      return "Không được phê duyệt";
    default:
      return "Đang phê duyệt";
  }
};
